import { useMemo } from 'react';
import { PillIconButton } from '../PreForm/components/PillIconButton';
import { getRolePillStyle } from '../PreForm/SignForm/helper';
import { FormRolesDropdown } from './FormRolesDropdown';
import styles from './styles.module.scss';

export const SLICED_FACTOR = 6;
export const SignFormRolesList = ({ roleOptions, allRoles, onAddRole }) => {
  const { rolesList, dropdownRoles } = useMemo(() => {
    if (roleOptions.length <= 6) return { rolesList: roleOptions, dropdownRoles: [] };

    let rolesList = roleOptions.slice(0, SLICED_FACTOR);
    let dropdownRoles = roleOptions.slice(SLICED_FACTOR, roleOptions.length);

    dropdownRoles = dropdownRoles.map((role) => {
      const { color } = getRolePillStyle(role, allRoles);
      return {
        ...role,
        color,
      };
    });

    return { rolesList, dropdownRoles };
  }, [roleOptions]);

  return (
    <div className={styles.signFormRolesList}>
      {rolesList?.map((role, index) => (
        <div key={role.Id}>
          <PillIconButton
            text={role.Name}
            className={styles.formRolePillButton}
            onClick={() => onAddRole(index)}
            style={{
              border: getRolePillStyle(role, allRoles).border,
              '--border-color-rgb': getRolePillStyle(role, allRoles).colorRGB,
            }}
          />
        </div>
      ))}

      {dropdownRoles?.length > 0 && (
        <FormRolesDropdown
          formRoles={dropdownRoles}
          onSelectRole={(index) => onAddRole(index + SLICED_FACTOR)}
        />
      )}
    </div>
  );
};
